import { MutationTree } from "vuex"
import { ActivityForUsers, Info } from "../../config"
import MUTATION_TYPES from "./mutation-types"
import { AppleGiftCardState, SelectedCoupon, UserRole, UserZone, UsingLocation } from "./state"
const mutations: MutationTree<AppleGiftCardState> = {
  [MUTATION_TYPES.SET_LOGIN_STATE](
    state: AppleGiftCardState,
    payload?: { openid: string; openkey: string; sessionId: string; sessionType: string }
  ): void {
    if (!payload) return
    const { openid, openkey, sessionId, sessionType } = payload
    state.openid = openid
    state.openkey = openkey
    state.sessionId = sessionId
    state.sessionType = sessionType
  },
  [MUTATION_TYPES.SET_WECHAT_REALNAME_TOKEN](state: AppleGiftCardState, token: string): void {
    state.wechatRealnameToken = token
  },
  [MUTATION_TYPES.SET_GOODS_PRICE_ITEM_INFO](state: AppleGiftCardState, productItem: Info["BUY_COLUMN"]): void {
    state.productItem = productItem
  },
  [MUTATION_TYPES.SET_USER_NOT_QUALIFIY_FULL_DISCOUNT](state: AppleGiftCardState, userDrmDiscountQualified: boolean): void {
    state.userDrmDiscountQualified = userDrmDiscountQualified
  },
  [MUTATION_TYPES.SET_AVAILABLE_COUPON](state: AppleGiftCardState, coupons: any): void {
    state.availableCoupons = coupons
  },
  [MUTATION_TYPES.SET_SELECTED_COUPON](state: AppleGiftCardState, coupon: SelectedCoupon | null): void {
    state.selectedCoupon = coupon
  },
  [MUTATION_TYPES.SET_USER_INFO](state: AppleGiftCardState, userInfo: any): void {
    state.userInfo = userInfo
  },
  [MUTATION_TYPES.SET_AGREE_CHECKED](state: AppleGiftCardState, agreeChecked: boolean): void {
    state.agreeChecked = agreeChecked
  },
  [MUTATION_TYPES.SET_IS_LOADING](state: AppleGiftCardState, isLoading: boolean): void {
    state.isLoading = isLoading
  },
  [MUTATION_TYPES.SET_BUY_NUM](state: AppleGiftCardState, buyNum: string): void {
    state.buyNum = buyNum
  },
  [MUTATION_TYPES.SET_MASK_ID](state: AppleGiftCardState, maskId: string): void {
    state.maskId = maskId
  },
  [MUTATION_TYPES.SET_HIDE_WARN](state: AppleGiftCardState, hideWarn: boolean): void {
    state.hideWarn = hideWarn
  },
  [MUTATION_TYPES.SET_TOAST_MSG](state: AppleGiftCardState, toastMsg: string): void {
    state.toastMsg = toastMsg
  },
  [MUTATION_TYPES.SET_TOAST_MSG_TIMER](state: AppleGiftCardState, toastMsgTimer: number | null): void {
    if (!toastMsgTimer && state.toastMsgTimer) clearTimeout(state.toastMsgTimer)
    state.toastMsgTimer = toastMsgTimer
  },
  [MUTATION_TYPES.SET_USING_LOCATION](state: AppleGiftCardState, usingLocation: UsingLocation): void {
    state.usingLocation = usingLocation
  },
  [MUTATION_TYPES.SET_NOT_SIGN](state: AppleGiftCardState, notSign: boolean): void {
    state.notSign = notSign
  },
  [MUTATION_TYPES.SET_IS_LOGGED_IN](state: AppleGiftCardState, isLoggedIn: boolean): void {
    state.isLoggedIn = isLoggedIn
  },
  [MUTATION_TYPES.SET_USER_ZONE](state: AppleGiftCardState, selectedZone: UserZone) {
    state.selectedZone = selectedZone
  },
  [MUTATION_TYPES.SET_USER_ROLE](state: AppleGiftCardState, selectedRole: UserRole) {
    state.selectedRole = selectedRole
  },
  [MUTATION_TYPES.CLEAR_ZONE](state: AppleGiftCardState) {
    state.selectedZone = state.selectedRole = null
  },
  [MUTATION_TYPES.SET_USER_TYPE_ACTIVITY](state: AppleGiftCardState, userTypeActivity: ActivityForUsers) {
    state.userTypeActivity = userTypeActivity
  }
}

export default mutations

export type AppleGiftCardMutations = typeof mutations
